import {useEffect, useState} from "react";
import {HideMainLoading, HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {Link, useParams} from "react-router-dom";
import {AuthRedirectAdmins, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {CurrencyFormat, StringDigitsConvertToPersian} from "../../../components/techaran/money";
import {GregorianToPersian} from "../../../components/techaran/date-convert";
import {GradeToString} from "../students/list";
import {CheckIcon, ThinNotAllowedIcon, ThinTimeIcon, TomansIcon} from "../../../components/icons/material-icons";

interface studentInterface {
    id: number,
    name: string,
    tell: string,
    national: string,
    grade: number,
    price: number,
    approved: boolean,
    approvedAt: string,
    createdAt: string,
    isPaid: boolean,
    paidAt: string,
    refNum: string,
    traceNo: string,
    rrn: string,
    securePan: string,
    declined: boolean,
}


export const AdminsSignupPrintStudents = () => {
    const [data, setData] = useState({
        loaded: false,
        list: [] as studentInterface[],
    });
    const fetchList = () => {
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/admins/presignup/list',
            {},
            true,
            (d: {
                result: string,
                reason: string,
                list: studentInterface[] | null,
                title: string,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                setData({
                    loaded: true,
                    list: d.list === null ? [] : d.list,
                });
            },
            () => {
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    useEffect(() => {
        document.title = "پرینت ثبت نام | اتوماسیون نهال";
        HideMainLoading();
        fetchList();
    }, []);
    return (
        <>
            <div className="print-screen">
                <button onClick={window.print}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
                        <path
                            d="M640-615.385v-120H320v120h-40v-160h400v160h-40Zm-456.923 40h593.846-593.846Zm521.538 100q17 0 28.5-11.5t11.5-28.5q0-17-11.5-28.5t-28.5-11.5q-17 0-28.5 11.5t-11.5 28.5q0 17 11.5 28.5t28.5 11.5ZM640-200v-181.538H320V-200h320Zm40 40H280v-160H143.077v-215.385q0-34 23.077-57t56.923-23h513.846q34 0 57 23t23 57V-320H680v160Zm96.923-200v-175.385q0-17-11.5-28.5t-28.5-11.5H223.077q-17 0-28.5 11.5t-11.5 28.5V-360H280v-61.539h400V-360h96.923Z"/>
                    </svg>
                    پرینت
                </button>
                <b>لیست پیش ثبت‌نام</b>
                <span>مدرسه هوشمند و مهارتی نهال</span>
                <table className="table open-table table-stripped table-bordered"
                       style={{display: 'table!important', border: 0}}>
                    <thead>
                    <tr>
                        <th>#</th>
                        <th>نام</th>
                        <th>تلفن</th>
                        <th>پایه</th>
                        <th>پیش پرداخت</th>
                        <th>وضعیت</th>
                        <th>پرداخت</th>
                        <th>تاریخ پرداخت</th>
                        <th>تاریخ ایجاد</th>
                    </tr>
                    </thead>
                    <tbody>
                    {
                        (data.list === null ? [] : data.list).map((s, i) =>
                            <tr key={"222K3339Esss4E1n2W222EK2__xS" + i}>
                                <td>{StringDigitsConvertToPersian(i + 1)}</td>
                                <td>{s.name}</td>
                                <td>{StringDigitsConvertToPersian(s.tell.replaceAll('+98', '0'))}</td>
                                <td>{GradeToString(s.grade)}</td>
                                <td><span>{CurrencyFormat(s.price)}<TomansIcon/></span></td>
                                <td>
                                    {
                                        s.approved ?
                                            'تایید شده' :
                                            (s.declined ?
                                                    'رد شده' :
                                                    'در انتظار'
                                            )
                                    }
                                </td>
                                <td>
                                    {
                                        s.isPaid ?
                                            'پرداخت شده':
                                            'عدم پرداخت'
                                    }
                                </td>
                                <td>{s.isPaid ? (StringDigitsConvertToPersian(s.paidAt.split(' ')[1] + " " + GregorianToPersian(s.paidAt.split(' ')[0]).replaceAll('-', '/'))) : '-'}</td>
                                <td>{StringDigitsConvertToPersian(s.createdAt.split(' ')[1] + " " + GregorianToPersian(s.createdAt.split(' ')[0]).replaceAll('-', '/'))}</td>
                            </tr>
                        )
                    }
                    </tbody>
                </table>
            </div>
        </>
    );
};